define('models/InstagramPostModel',['underscore', 'ObjectModel', 'app'], function (_, ObjectModel, app) {
    var InstagramPostModelPrototype = {

        name: 'InstagramPostModel',
        idAttribute: 'id_insta_post',
        route: 'apiInstagramPostModel',
        initialize: function () {
            ObjectModel.prototype.initialize.apply(this, arguments);
        },
        getProducts: function () {
            var model = this;
            return model.get('products');
        },
        getFirstProduct: function(){
            var products = this.getProductInContext();
            return products.length ? products[0] : null;
        },
        getProductInContext: function () {
            var model = this, productsIds =  model.getProducts() , products = [];

            if (!_.isUndefined(productsIds) && productsIds) {
                productsIds.forEach(function (productId) {
                    var product = app.getProduct(productId);
                    if (product && product.isVisibleInContext()) {
                        products.push(product);
                    }


                });
            }
            return products;
        },
    };

    return ObjectModel.extend(InstagramPostModelPrototype);
});
